import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User edits session duration number input',
  name: 'edited_session_duration_number',
  params: [
    {
      description: 'Duration period (in seconds)',
      name: 'session_duration_time',
      required: true,
      type: 'number',
    },
    {
      description: 'The numerical value the user inputed into the text field',
      name: 'session_duration_number',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
